export function superToggle(e, classes) {
    for (let a of classes) {
        e.classList.toggle(a);
    }
}